import { COMMUNICATION_SUMMARY, COMPANY_ENGAGEMENTS_SUMMARY, COMPANY_NEWS, COMPANY_TECH, OBJECT_SUMMARY } from '../constants/CopilotInAppActionTypes';
import { objectSummary } from './parsers/objectSummary';
import { companyNews } from './parsers/companyNews';
import { companyTech } from './parsers/companyTech';
import { communicationSummary } from './parsers/communicationSummary';
import { companyEngagementsSummary } from './parsers/companyEngagementsSummary';
const buildMessageAction = partialMessageAction => {
  return Object.assign({
    form: null,
    format: null,
    link: null,
    module: null,
    openai_config: null,
    title: ''
  }, partialMessageAction);
};
export const parseInAppCopilotAction = inAppMessageAction => {
  let parsedAction = undefined;
  switch (inAppMessageAction.intent) {
    case OBJECT_SUMMARY:
      parsedAction = objectSummary(inAppMessageAction);
      break;
    case COMPANY_NEWS:
      parsedAction = companyNews(inAppMessageAction);
      break;
    case COMPANY_TECH:
      parsedAction = companyTech(inAppMessageAction);
      break;
    case COMMUNICATION_SUMMARY:
      parsedAction = communicationSummary(inAppMessageAction);
      break;
    case COMPANY_ENGAGEMENTS_SUMMARY:
      parsedAction = companyEngagementsSummary(inAppMessageAction);
      break;
    default:
      parsedAction = undefined;
  }
  if (parsedAction === undefined) {
    return undefined;
  }
  return buildMessageAction(parsedAction);
};